import './style.scss';

import React from 'react';
import classnames from 'classnames';
import Avatar from './Avatar';
import LoadingSpinner from 'scy/LoadingSpinner';
import ProgressBar from 'scy/ProgressBar';
import { pluralize, localizeNumber } from 'shared/utils';
import { pointsToNextStatus, statusBackgroundStyles } from './helpers';
import {
  sansSerifLight,
  sansSerifBlack,
  fontSizeXXS,
  fontSizeS,
  lineHeightXS,
  lineHeightS,
  darkBgPrimary,
  accent
} from 'scy/text/styles.mod.scss';
import { H5, SmallUppercase } from 'scy/text';
import { textCenter } from 'scy/utils.mod.scss';
import { relative } from 'scy/position.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import { borderRadius } from 'scy/border.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function LoyaltyUserSummary({
  currentPoints,
  currentStatus,
  nextStatus,
  user,
  loading
}) {
  if (!user) return null;

  return (
    <div className={textCenter}>
      <Avatar user={user} />

      <div
        className={classnames(sansSerifBlack, fontSizeS, lineHeightS, accent)}
      >
        {user.firstname} {user.lastname}
      </div>

      {!!currentStatus && (
        <H5
          uppercase
          tag="div"
          className={classnames(
            inlineBlock,
            padding.top_xxs,
            padding.bottom_xxs,
            padding.left_xs,
            padding.right_xs,
            margin.xxs,
            darkBgPrimary,
            borderRadius
          )}
          style={statusBackgroundStyles(currentStatus, 'to right')}
        >
          {currentStatus.name} Status
        </H5>
      )}

      {loading ? (
        <div className={classnames(relative, padding.sm)}>
          <LoadingSpinner black />
        </div>
      ) : (
        <div
          className={classnames(
            margin.bottom_xs,
            fontSizeXXS,
            lineHeightXS,
            accent,
            sansSerifLight
          )}
        >
          {localizeNumber(currentPoints)} {pluralize('point', currentPoints)}
        </div>
      )}

      {!!nextStatus && !currentStatus && (
        <>
          <ProgressBar
            percentage={(100 * currentPoints) / nextStatus.point_value}
            color={nextStatus.primary_color}
            className={styles.progressBar}
          />
          <SmallUppercase tag="div" className={accent}>
            {pointsToNextStatus(currentPoints, nextStatus)}
          </SmallUppercase>
        </>
      )}
    </div>
  );
}
